var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCareersTrust = function SvgCareersTrust(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#careers-trust_svg__a)",
    fillRule: "evenodd",
    d: "M5.858 5.86c7.81-7.81 20.474-7.814 28.29-.009 7.803 7.82 7.803 20.478 0 28.298-7.816 7.805-20.48 7.8-28.29-.01s-7.81-20.469 0-28.279m.774 27.535c7.38 7.38 19.349 7.382 26.733.004v-.033c7.353-7.382 7.353-19.317 0-26.7C25.98-.71 14.013-.708 6.631 6.672s-7.381 19.344 0 26.724",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#careers-trust_svg__b)",
    d: "m28.042 15.162-9.79 9.544-5.331-5.188a.547.547 0 0 0-.767 0 .517.517 0 0 0 0 .737l5.753 5.598c.216.196.55.196.766 0L28.84 15.93a.52.52 0 0 0 0-.747.545.545 0 0 0-.798-.021"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "careers-trust_svg__a",
    x1: 0,
    x2: 40,
    y1: 40,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB77C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E95F48"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "careers-trust_svg__b",
    x1: 12,
    x2: 22.034,
    y1: 26,
    y2: 10.493,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB77C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E95F48"
  })))));
};
export { SvgCareersTrust as ReactComponent };
export default __webpack_public_path__ + "fonts/careers-trust-cf566df698836498992cf064008bab8c.svg";